import {
  BOOKING_BULK_FORM_FIELDS,
  DirectionEnum,
  isValidPositiveNumber,
} from "@ryde/shared";

import type {
  IFromWorkAutofill,
  TFromWorkStationFieldName,
  TToWorkStationFieldName,
} from "../bulk-bookings.models";

export const getFromWorkFieldName = (
  toWorkFieldName: TToWorkStationFieldName,
): TFromWorkStationFieldName =>
  toWorkFieldName === BOOKING_BULK_FORM_FIELDS.originStationIdA
    ? BOOKING_BULK_FORM_FIELDS.destinationStationIdB
    : BOOKING_BULK_FORM_FIELDS.originStationIdB;

/** From Work follows To Work only while it is empty or still holds the station autofill put there. */
export const resolveFromWorkAutofill = ({
  direction,
  toWorkStationId,
  fromWorkStationId,
  autofilledStationId,
}: {
  direction: DirectionEnum;
  toWorkStationId: unknown;
  fromWorkStationId: unknown;
  autofilledStationId: number | undefined;
}): IFromWorkAutofill | undefined => {
  if (direction !== DirectionEnum.Both) {
    return undefined;
  }

  const currentStationId = isValidPositiveNumber(fromWorkStationId)
    ? fromWorkStationId
    : null;

  // A station the operator or the passenger prefill put in From Work is theirs to keep.
  if (currentStationId !== null && currentStationId !== autofilledStationId) {
    return undefined;
  }

  const stationId = isValidPositiveNumber(toWorkStationId)
    ? toWorkStationId
    : null;

  if (stationId === currentStationId) {
    return undefined;
  }

  return { stationId } satisfies IFromWorkAutofill;
};
